import { formatDate } from "../../utils/helpers";

export const usePRNs = () => {
  const tableColumns = () => [
    { id: "ref", header: "PRN" },
    { id: "payment_mode_name", header: "Payment Mode" },
    { id: "amount", header: "Amount" },
    { id: "actions", header: "Actions" },
  ];

  const tableData = (data: any) => [
    ...data?.map((item: any) => {
      const row = {
        ...item,
        actions: item.status === "C" ? "Credited" : "Available",
        created_at: formatDate(item.created_at),
      };
      return row;
    }),
  ];

  const viewData = (item: any) => {
    return {
      reference_number: item?.reference_number,
      description: item?.description,
      amount: item?.amount,
      entry_type: item?.entry_type,
      entry_period: item?.entry_period,
      debit_account: item?.debit_account,
      credit_account: item?.credit_account,
      member_account: item?.member_account,
      due_date: formatDate(item?.due_date),
      next_date: formatDate(item?.next_date),
      created_at: formatDate(item?.created_at),
    };
  };

  return { tableColumns, tableData, viewData };
};
